import { Box, Chip } from "@mui/material";
import React, { useEffect, useState } from "react";
import SelectServiceProvider from "./SelectProviderService";
import toast from "react-hot-toast";
import { handleError } from "../../../../utils/handleError";
import Loading from "../../../../components/Loading/Loading";
import WrapFiles from "./WrapListFiles";
import { useDispatch, useSelector } from "react-redux";
import useContractedSpecialist from "../../../../hooks/useContractedSpecialist";
import { gettAllSpecialist } from "../../../../services/rest/servicesProvider/servicesProvider";
import { getAllPatientsOfProvider } from "../../../../services/rest/users/userProviderService";
import { setListSpecialists } from "../../../../redux/slice/specialistSlice";

const TrainingScreen = () => {
  const { _id, status } = useSelector((state) => state.userReducer);
  const { membershipStatus } = useSelector((state) => state.membershipReducer);
  const { listCoaches } = useSelector((state) => state.specialistReducer);
  const [loading, setLoading] = useState(true);
  const [selectedChip, setSelectedChip] = useState("provider");
  const dispatch = useDispatch();

  const {
    isContractedService,
    inforProviderContrated,
    checkContractedSpecialist,
  } = useContractedSpecialist({ loading, setLoading });

  const handleCheckNutricionists = async () => {
    await checkContractedSpecialist({
      specialistList: listCoaches,
      currentUserId: _id,
      getAllSpecialistFn: gettAllSpecialist,
      getAllPatientsOfProviderFn: getAllPatientsOfProvider,
      dispatch,
      setListSpecialistsAction: setListSpecialists,
    });
  };

  useEffect(() => {
    handleCheckNutricionists();
  }, []);

  return (
    <Box
      sx={{
        paddingLeft: 4,
        paddingRight: 4,
        display: "flex",
        flexDirection: "column",
        gap: 4,
      }}
    >
      <Loading loading={loading} />
      <Box sx={{ display: "flex", gap: 5 }}>
        <Chip
          label="Mi Entrenador"
          variant={"filled"}
          style={
            selectedChip === "provider"
              ? {
                  backgroundColor: "#e7ef7d",
                  color: "black",
                }
              : {}
          }
          onClick={() =>
            isContractedService
              ? setSelectedChip("provider")
              : toast.error(
                  "No tienes contratado el servicio.\n Elige un Entrenador."
                )
          }
        />
        <Chip
          label="Lista de Entrenadores"
          style={
            selectedChip === "listProviders"
              ? {
                  backgroundColor: "#e7ef7d",
                  color: "black",
                }
              : {}
          }
          onClick={() => setSelectedChip("listProviders")}
        />
      </Box>
      <Box>
        {selectedChip === "listProviders" && (
          <SelectServiceProvider listServiceProviders={listCoaches} />
        )}
        {isContractedService &&
          selectedChip === "provider" &&
          status === "active" &&
          membershipStatus === "active" && (
            <WrapFiles
              inforProviderContrated={inforProviderContrated}
              typeService={"Entrenador"}
              setLoading={setLoading}
            />
          )}
      </Box>
    </Box>
  );
};

export default TrainingScreen;
